import Node from './node';

export default class Modal extends Node {
  clone() {
    return new Modal(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
